<template>
  <header class="p-4" :is-editor="false" :workflow-model="null" :authentication="authentication" />
  <div class="custom-padding flex-grow-1 overflow-auto">
    <h1 class="display-3 fw-lighter">Contact</h1>
    <div class="py-5">
      <p class="fs-3 fw-bolder">A Product of Wako GmbH</p>
      <p class="fs-3 fw-lighter">Strasserau 6, 4020 Linz, Austria</p>
      <p class="fs-3 fw-lighter">Granitweg 1, 4202 Kirchschlag bei Linz, Austria</p>
      <br />
      <p class="fs-3 fw-lighter">Phone: +43 664 5462070</p>
      <p class="fs-3 fw-lighter">E-mail: office@cekoon.com</p>
    </div>
    <div class="pb-3">
      <p class="fs-3 fw-lighter">Do you need more information?</p>
      <p class="fs-3 fw-lighter">Please leave us your message here, we will directly contact you.</p>
    </div>
    <form>
      <div class="input-group my-2">
        <span id="basic-addon3" class="input-group-text">Name</span>
        <input id="basic-url" type="text" class="form-control" aria-describedby="basic-addon3 basic-addon4" />
      </div>
      <div class="input-group my-2">
        <span id="basic-addon3" class="input-group-text">Email</span>
        <input id="basic-url" type="email" class="form-control" aria-describedby="basic-addon3 basic-addon4" />
      </div>
      <div class="input-group mb-5">
        <span class="input-group-text">Message</span>
        <textarea class="form-control" aria-label="With textarea"></textarea>
      </div>
      <hr />
      <div class="py-2">
        <p class="fs-3 fw-lighter">Data Protection</p>
        <div class="form-check">
          <input id="flexCheckDefault" class="form-check-input" type="checkbox" value="" />
          <label class="form-check-label fs-3 fw-lighter" for="flexCheckDefault"
            >Yes, I have read the <a href="" class="text-dark">privacy policy</a> and I accept it.</label
          >
        </div>
      </div>
      <hr />
      <p class="fs-3 fw-lighter mt-5">CAPTCHA</p>
      <re-captcha />
      <button type="submit" class="btn btn-dark btn-lg custom-rounded fs-3 fw-lighter">Submit</button>
    </form>
  </div>
  <footer :is-editor="false" class="p-4" />
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';

import Auth from '@/services/api/auth';
import { Role } from '@/types/enum/user';
import { User } from '@/types/api/User/User';
import Header from '@/components/layout/Header.vue';
import Footer from '@/components/layout/Footer.vue';
import ReCaptcha from '@/components/features/ReCaptcha.vue';
import { useRoute } from 'vue-router';

@Component({
  components: {
    Header,
    Footer,
    ReCaptcha,
  },
})

export default class ContactPage extends Vue {
  authentication = Auth.getInstance();
  menuLoading = false;
  Role = Role;
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding-right: 10rem;
  padding-left: 10rem;
  padding-top: 6rem;
  padding-bottom: 4rem;
}
.form-control {
  border-color: white !important;
}
.input-group-text {
  border-color: white !important;
}
.form-check {
  padding-top: 5px;
  padding-bottom: 20px;
}
.form-check-input {
  margin-top: 5px;
  margin-right: 15px;
  width: 20px;
  height: 20px;
}
.custom-rounded {
  border-radius: 0.25rem !important;
}
</style>
